import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  AfterViewChecked
} from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute
} from '@angular/router';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { has, toStringArray } from '@tmhcc/util';
import { AppConfigService, SaveChangeGaurd } from '@tmhcc-ng-lib/global-services';
import { SummaryContentService } from '@tmhcc-ng-lib/content-service';
import {
  SubCompany,
  AppDataService,
  StepsService,
  StepResponse,
  StepRequest,
  GlobalVariablesService,
  CustomLoginService
} from '@tmhcc-ng-lib/data-service';
import { DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { DialogConfig } from '@tmhcc-ng-lib/framwork/dialog';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';
import { HeaderContentService } from '@tmhcc-ng-lib/content-service';
import { HeaderContentType } from 'libs/content-service/def/header-content';
import { Title } from '@angular/platform-browser';
import { filter, map, switchMap } from 'rxjs/operators';
import {
  Config,
  CustomLoginComponent,
  Menu,
  StepNevigationService
} from '@tmhcc/artisan-edge';
import { Subscription } from 'rxjs';
import { StepsContentService } from '@tmhcc-ng-lib/content-service';
import { CommonContentService } from '@tmhcc-ng-lib/content-service';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';

import {
  AllowedRoutes,
  AllowedPLNavRoutes,
  AllowedPRNavRoutes,
  AllowedBRNavRoutes,
  AllowedCENavRoutes,
  ProductsNavRoutes,
  ProductType,
  HeaderMenu,
  Status,
  PageUrl,
  PageTitle,
  UpdatePolicy,
  AllowedEXNavRoutes,
  PLSubmissionRoutes,
  PRSubmissionRoutes,
  BRSubmissionRoutes,
  EXSubmissionRoutes,
  CESubmissionRoutes,
  Messages,
  ActiveSessionTime
} from '@tmhcc-ng-lib/models';
import {
  AllowedGLNavRoutes,
  GLSubmissionRoutes
} from 'libs/models/enums/gl-menus.model';
import { IsTrue } from 'libs/util/binary-util';
import { DialogSize } from '@tmhcc-ng-lib/framwork/dialog';
import { DialogContainerComponent } from '@tmhcc-ng-lib/global-services';
declare let ga: Function;
declare var $: any;

@Component({
  selector: 'ae-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  artisan = 'Artisan ::';

  productList;
  topHeaderDropdownList;
  title = 'Artisan Edge 2.0 Dashboard';
  menuFlag: string = 'verify';
  dashboardFlag: boolean;
  isUserLogin: boolean = false;
  isAuthenticated: boolean;
  loggedInUser;
  userData;
  isLoading: boolean;
  showLogout: boolean;
  showQuotes: boolean = false;
  showSubCompanyList: boolean;
  subCompanyList: SubCompany[];
  selectedSubCompany: string;
  selectedSubCompanyCode: string;
  showSubCompanyAsLabel = true;
  isDataAvailable: boolean = false;
  currentUrl: string = HeaderMenu.Artisan;
  customerService;
  stepSubscription: Subscription;
  summaryPanel: StepResponse;
  summaryContent;
  summaryFlag: boolean = false;
  uwMessageFlag: boolean = false;
  refralMessageFlag: boolean = false;
  policyStatus: string;
  submissionType: string;
  submissionDescription: string;
  hideHeader: boolean;
  hideFooter: boolean;
  hideSave: boolean;
  hideHeaderX: boolean;
  titleText: string;
  navigationUrl: string;
  idleTimeout: number = ActiveSessionTime; // 30 seconds
  isIdle: boolean = false;

  modalContent: DialogConfig = {
    data: {
      para: '',
      phone: '',
      email: ''
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false,
      hideSave: true,
      closeOnOutsideClick: true
    }
  };

  headerData: HeaderContentType;
  customerServiceText;
  logoutMsg: any;
  collapsed: any;
  options: Config = { multi: false };

  menus: Menu[];
  generalLiabilityUrls: any[];
  allowRoutes;
  private policyTypeId: any;
  private subCompanyCode: any;
  private name: any;

  constructor(
    public dialogService: DialogService,
    public oktaAuth: OktaAuthService,
    public router: Router,
    public loaderService: LoaderService,
    protected configService: AppConfigService,
    private appDataService: AppDataService,
    private headerContentService: HeaderContentService,

    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private stepsService: StepsService,
    private cdref: ChangeDetectorRef,
    private summaryContentService: SummaryContentService,
    private stepsContentService: StepsContentService,
    private commonContentService: CommonContentService,

    private alertService: AlertTosterService,

    private globalVariables: GlobalVariablesService,
    private activeRoute: ActivatedRoute,
    private customLogin: CustomLoginService,
    protected stepNevigationService: StepNevigationService,
    public dialogConfig: DialogConfig,
    private saveChangeGaurd: SaveChangeGaurd,
  ) {
    //Okta login authentication subscriber
    this.oktaAuth.$authenticationState.subscribe(
      (isAuthenticated: boolean) => (this.isAuthenticated = isAuthenticated)
    );

    this.loaderService.isLoading.subscribe(loader => {
      setTimeout(() => {
        this.isLoading = loader;
        if (!loader) this.cdref.detectChanges();
      }, 10);
    });
    this.loaderService.show();

    document.body.onclick = e => {
      if (
        $(e.target).hasClass('navbar-toggler-icon') ||
        $(e.target).hasClass('navbar-toggler')
      ) {
        return;
      }

      if ($('.navbar-toggler').attr('aria-expanded') == 'true') {
        $('.navbar-toggler')[0].click();
      }      
    };

    this.appDataService.showSummary.subscribe(enableSummary => {
      this.summaryFlag = false;
      if (enableSummary) {
        this.summaryFlag = enableSummary;
        this.cdref.detectChanges();
      }

      this.appDataService.getPolicyDetails().subscribe(res => {
        if (res) {
          if (
            this.globalVariables.browserRefreshed &&
            res.SummaryDetails.SummaryPendingItem.PolicyStatus !=
            this.globalVariables.oldPolicyStatus
          ) {
            this.stepNevigationService.stepNevigation(res, true);
          }
          this.globalVariables.oldPolicyStatus =
            res.SummaryDetails.SummaryPendingItem.PolicyStatus;
          this.getCoveragesData(res);
        }
      });
    });

    this.startTracking();
  }

  startTracking() {
    let timer: any;

    const resetTimer = () => {
      clearTimeout(timer);
      this.isIdle = false;
      timer = setTimeout(() => {
        this.isIdle = true;
        this.logout();
      }, this.idleTimeout);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);

    resetTimer();
  }

  async ngOnInit() {
    this.commonContentService.setPageTitle();
    this.appDataService.getPolicyDetails().subscribe(res => {
      this.getCoveragesData(res);
      const sendBack = res?.SummaryDetails?.SummaryPendingItem.PolicyStatus;
      if (
        sendBack == UpdatePolicy.Step1AUpdate ||
        sendBack == UpdatePolicy.Step1BUpdate ||
        sendBack == UpdatePolicy.Step1CUpdate ||
        sendBack == UpdatePolicy.Step2AUpdate ||
        sendBack == UpdatePolicy.Step2BUpdate ||
        sendBack == UpdatePolicy.Step2CUpdate ||
        sendBack == UpdatePolicy.Step3AUpdate ||
        sendBack == UpdatePolicy.Step3BUpdate ||
        sendBack == UpdatePolicy.Step3CUpdate
      ) {
        this.uwMessageFlag = true;
      } else {
        this.uwMessageFlag = false;
      }
    });

    if (!this.isAuthenticated) {
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    }
    if (this.isAuthenticated) {
      await this.setWelcomeUser();
    }
    //Custom login authentication subscriber
    this.customLogin.isAuthenticated.subscribe((isAuthenticated: boolean) => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        sessionStorage.setItem(
          'UserId',
          this.globalVariables.loginMFAInfo.Username
        );
        this.isUserLogin = true;
      }
    });
    this.appDataService.logoutMsg.subscribe(res => {
      this.logoutMsg = res;
      this.isUserLogin = false;
    });

    let userId = sessionStorage.getItem('UserId');
    if (userId) {
      this.isUserLogin = true;
    } else {
      this.isUserLogin = false;
    }
    let url = window.location.href;
    let login = url.includes('login');
    if (login) {
      localStorage.clear();
      sessionStorage.clear();
      this.isUserLogin = false;
    }

    this.getUserSessoinStorage();
    this.headerContentService.data$.subscribe(res => {
      this.callHeaderData(res);

      if (res) {
        this.modalContent.data = {
          para: res.data[0].description,
          phone: res.data[0].displayItems[1].description,
          email: res.data[0].displayItems[2].description,
          claimContact: res.data[0].displayItems[0].description,
        };
        this.modalContent.modalSetting = {
          title: res.data[0].heading,
          hideFooter: true
        };
      }
    });

    const addMaximumScaleToMetaViewport = () => {
      const el = document.querySelector('meta[name=viewport]');
      if (el !== null) {
        let content = el.getAttribute('content');
        let re = /maximum\-scale=[0-9\.]+/g;

        if (re.test(content)) {
          content = content.replace(re, 'maximum-scale=1.0');
        } else {
          content = [content, 'maximum-scale=1.0'].join(', ');
        }
        el.setAttribute('content', content);
      }
    };
    const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;
    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    }
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        var rt = this.getChild(this.activatedRoute);
        rt.data.subscribe(data => {
          this.titleService.setTitle(data.title);
        });

        const agentInfo = this.globalVariables.agentInfo;
        if (agentInfo && agentInfo.ContactId) {
          ga('set', 'page', (event as any).urlAfterRedirects);
          ga('send', 'pageview', {
            dimension1: agentInfo.ContactId + ' ' + agentInfo.Name
          });
        }
      });

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects == AllowedRoutes.Dashboard || event.urlAfterRedirects.includes(AllowedRoutes.Dashboard)) {
          this.dashboardFlag = true;
        } else {
          this.dashboardFlag = false;
        }
      }
    });

    this.summaryContentService.data$.subscribe(res => {
      if (res) {
        this.summaryContent = res;
      }
    });
  }

  getStepsMenu() {
    let filteredMenu;
    this.commonContentService.setPageTitle();
    this.appDataService.stepsSitecoreContent.subscribe(r => {
      this.stepsContentService.data$.subscribe(res => {
        if (res) {
          if (this.globalVariables.policyStatus == Status.PendingReview) {
            filteredMenu = res.sidemenu.filter(item => {
              return item.name !== 'Verify & Purchase';
            });
          } else {
            filteredMenu = res.sidemenu.filter(item => {
              return item.name !== 'Pending Review';
            });
          }
          if (!this.currentUrl.includes('renewalreview')) {
            filteredMenu = filteredMenu.filter(item => {
              return item.name !== 'Renewal Review';
            });
          }

          this.appDataService.setStepsSitecoreData(res);
          this.menus = this.repositionRenewalMenu(filteredMenu);
          if (this.generalLiabilityUrls.includes(this.currentUrl)) {
            this.openSubmenuBasedOnUrl(this.currentUrl);
          }
        }
      });
    });
    this.cdref.detectChanges();
  }

  repositionRenewalMenu(filteredMenu: Array<any>) {
    let renewalIndex = filteredMenu.findIndex(
      item => item.name === 'Renewal Review'
    );
    if (renewalIndex >= 0) {
      let renewalItem = filteredMenu.find(
        item => item.name === 'Renewal Review'
      );
      let tempObj = filteredMenu[renewalIndex - 1];
      filteredMenu[renewalIndex - 1] = renewalItem;
      filteredMenu[renewalIndex] = tempObj;
    }
    return filteredMenu;
  }

  openSubmenuBasedOnUrl(url: string) {
    this.commonContentService.setPageTitle();

    if (!this.menus) return;
    this.menus.forEach(menu => {
      menu.active = false;
      if (menu && menu.submenu) {
        menu.submenu.filter(link => {
          if (link.url == url) {
            menu.active = true;
          }
        });
      }
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    this.commonContentService.setPageTitle();

    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  stopMenuClose(e) {
    if (window.innerWidth < 768) {
      e.stopPropagation();
    } else {
      return;
    }
  }
  callHeaderData(data) {
    this.commonContentService.setPageTitle();

    if (data) {
      this.headerData = data;

      this.productList = this.headerContentService.getProductMenu(
        data.headerDropdown[0].displayItems
      );
       //TODO:  test after login
      this.productList =this.productList.filter(item => {
        return item.Name !== 'Pollution Liability';
      });
      this.headerData.headerDropdown[1].displayItems=this.headerData.headerDropdown[1].displayItems.filter(item => {
        return item.keyText !== 'Artisan Pollution Liability';
      });
      this.customerService = this.headerData.mainLinks[0].displayItems.filter(
        name => {
          return name.keyText.includes(HeaderMenu.CustomerService);
        }
      );
      this.topHeaderDropdownList = this.headerContentService.topHeaderDropdown(
        data.topHeaderDropdown[0].displayItems
      );
      this.isDataAvailable = true;
    }
  }

  welcomeLink(label) {
    switch (label) {
      case HeaderMenu.Settings:
        '';
        break;
      case HeaderMenu.Logout:
        this.navigationUrl = HeaderMenu.Logout;
        break;
      case HeaderMenu.Search:
        this.navigationUrl = HeaderMenu.Search;
        break;
      case HeaderMenu.AccountSettings:
        this.navigationUrl = HeaderMenu.AccountSettings;
        break;
      case HeaderMenu.Surety:
        this.navigationUrl = HeaderMenu.Surety;
        break;
      case HeaderMenu.AgencyAdmin:
        this.navigationUrl = HeaderMenu.AgencyAdmin;
        break;
    }
    this.NavigateToHeaderLink("welcome");
  }

  getUserSessoinStorage() {
    this.commonContentService.setPageTitle();

    this.userData = JSON.parse(sessionStorage.getItem('userDetails'));
    if (this.userData) {
      this.loggedInUser = this.userData.AgentInfo.Name;
    }
    this.appDataService.changeStorage.subscribe(res => {
      if (res) {
        this.userData = res;
        this.loggedInUser = this.userData.AgentInfo.Name;
      }
    });
  }

  openModal() {
    this.dialogService.open(CustomModalComponent, this.modalContent);
  }

  async ngAfterViewInit() {
    this.loaderService.hide();

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.globalVariables.browserRefreshed = !this.router.navigated;        
      } else if (event instanceof NavigationEnd) {
        this.commonContentService.setPageTitle();

        let prodType = this.globalVariables.productName;
        if (prodType) {
          let navRputes = ProductsNavRoutes[prodType];
          this.generalLiabilityUrls = toStringArray(navRputes);

          if (this.generalLiabilityUrls.includes(event.url)) {
            this.currentUrl = event.url;
            this.globalVariables.enableStep(this.currentUrl);
            this.openSubmenuBasedOnUrl(event.url);
            this.getStepsMenu();
            this.enableDisableStepMenu(prodType);
          } else {
            this.currentUrl = HeaderMenu.Artisan;
          }
        } else {
          this.currentUrl = HeaderMenu.Artisan;
        }
      }
    });
  }

  enableDisableStepMenu(prodType) {
    const isStep4 =
      this.currentUrl.includes('verify-purchase') ||
      this.currentUrl.includes('pending-review');
    if (isStep4) {
      this.summaryFlag = IsTrue(this.globalVariables.isSummaryEnable);
    }
    if (!isStep4) {
      this.globalVariables.resetSteps();
      this.policyStatus = 'Step1A';
      this.submissionType = Status.Renewal;
      this.setNavigationStep(prodType);
      this.appDataService.getPolicyDetails().subscribe(res => {
        if (res) this.getCoveragesData(res);
        if (res.SummaryDetails?.SummaryPendingItem.PolicyStatus) {
          this.policyStatus =
            res.SummaryDetails?.SummaryPendingItem.PolicyStatus;
          this.setNavigationStep(prodType);
        } else {
          this.policyStatus = 'Step1A';
        }
      });
    } else {
      for (let step in this.globalVariables.allSteps[prodType]) {
        this.globalVariables.allSteps[prodType][step] = true;
      }
    }
  }

  validateLeftNav(param: boolean) {
    if (this.globalVariables.policyStatus != Status.PendingReview) {
      return true;
    }
    return param;
  }
  setNavigationStep(prodType) {
    this.commonContentService.setPageTitle();

    for (let step in this.globalVariables.allSteps[prodType]) {
      this.globalVariables.allSteps[prodType][step] = true;
      if (step === this.setUrlBasedOnStatus(this.policyStatus)) break;
    }
  }

  setUrlBasedOnStatus(policyStatus) {
    this.commonContentService.setPageTitle();

    let prodName = this.globalVariables.productName;
    let url: string = '';
    switch (prodName) {
      case ProductType.General:
        return (url = GLSubmissionRoutes[policyStatus]);
      case ProductType.Pollution:
        return (url = PLSubmissionRoutes[policyStatus]);
      case ProductType.Professional:
        return (url = PRSubmissionRoutes[policyStatus]);
      case ProductType.Builders:
        return (url = BRSubmissionRoutes[policyStatus]);
      case ProductType.Excess:
        return (url = EXSubmissionRoutes[policyStatus]);
      case ProductType.Contractors:
        return (url = CESubmissionRoutes[policyStatus]);
    }
  }
  getCoveragesData(data) {
    this.summaryPanel = { ...data };
    let description = this.summaryPanel.SummaryDetails?.SummaryPendingItem
      .SubmissionStatusDescription;
    if (description) {
      this.submissionDescription = description.split('\n').join('<br>');
    }
    sessionStorage.policyTxnId = data.PolicyTxnId;
    this.refralReason();
    this.cdref.detectChanges();
  }

  newQuote(name, policyTypeId, subCompanyCode) {
    this.name = name;
    this.policyTypeId = policyTypeId;
    this.subCompanyCode = subCompanyCode;
    switch (this.name) {
      case ProductType.General:
      case ProductType.RemodelingGL:
        this.navigationUrl = AllowedGLNavRoutes.Insured;
        break;
      case ProductType.Pollution:
        this.navigationUrl = AllowedPLNavRoutes.Insured;
        break;
      case ProductType.Professional:
        this.navigationUrl = AllowedPRNavRoutes.Insured;
        break;
      case ProductType.Builders:
        this.navigationUrl = AllowedBRNavRoutes.Insured;
        break;
      case ProductType.Excess:
        this.navigationUrl = AllowedEXNavRoutes.Insured;
        break;
      case ProductType.Contractors:
        this.navigationUrl = AllowedCENavRoutes.Insured;
        break;
      case HeaderMenu.Search:
        this.navigationUrl = AllowedRoutes.Dashboard;
        break;
      default:
        this.navigationUrl = AllowedRoutes.Dashboard;
    }
    this.NavigateToHeaderLink("newquote");
  }

  resetPropertyOnNewQuote() {
    this.commonContentService.setPageTitle();

    this.globalVariables.resetGlobalVariableCache();
    this.globalVariables.isSummaryEnable = 'false';
    this.summaryFlag = false;
    this.appDataService.showSummary.next(false);
    this.refralMessageFlag = false;
  }

  refralReason() {
    this.commonContentService.setPageTitle();

    let uWMessage = this.summaryPanel?.SummaryDetails?.SummaryPendingItem;
    if (
      (uWMessage.SubmissionStatus === 'Pending Underwriter Review' &&
        uWMessage.SubmissionStatusDescription) ||
      (uWMessage.SubmissionType === 'Endorsement' &&
        uWMessage.SubmissionStatusDescription)
    ) {
      this.refralMessageFlag = true;
    } else {
      this.refralMessageFlag = false;
    }
  }
  headerLink(name) {
    this.commonContentService.setPageTitle();

    switch (name) {
      case HeaderMenu.NewsFeed:
        this.navigationUrl = AllowedRoutes.NewsFeed;
        break;
      case HeaderMenu.Dashboard:
        this.navigationUrl = AllowedRoutes.Dashboard;
        break;
      case HeaderMenu.Search:
        this.navigationUrl = AllowedRoutes.Dashboard;
        break;
      case HeaderMenu.CustomerService:
        this.navigationUrl = AllowedRoutes.ContactUs;
        break;
      case HeaderMenu.Search:
        this.navigationUrl = AllowedRoutes.Dashboard;
        break;
      case HeaderMenu.BaseUrl:
        this.navigationUrl = AllowedRoutes.BaseUrl;
        break;
      default:
        this.navigationUrl = AllowedRoutes.Login;
    }
    this.NavigateToHeaderLink("header");
  }
  supportRequest() {
    this.router.navigate([AllowedRoutes.RequestAccess]);
  }

  async setWelcomeUser() {
    const userClaims = await this.oktaAuth.getUser();
    if (has(userClaims, 'email')) {
      sessionStorage.setItem('UserId', userClaims.email);
    }
  }

  async logout() {
    this.isUserLogin = false;
    this.router.navigate([AllowedRoutes.Login]);
  }

  public popupLogoutOnClick = false;
  closeLogoutPopup(event) {
    if (this.showLogout && !this.popupLogoutOnClick) {
      this.showLogout = false;
    } else {
      this.popupLogoutOnClick = false;
    }
  }

  public popupsubMenuOnClick = false;
  closeNewClaimPopup(e) {
    this.commonContentService.setPageTitle();

    if (this.showQuotes && !this.popupsubMenuOnClick) {
      this.showQuotes = false;
    } else {
      this.popupsubMenuOnClick = false;
    }
  }
  ngOnDestroy() {
    this.stepSubscription.unsubscribe();
  }

  public Surety() {
    this.customLogin.loginSurety().subscribe(
      data => {
        var suretyResponse = data;
        if (suretyResponse.Status == 'SUCCESS') {
          this.router.navigate(['/']).then(result => {
            window.location.href = suretyResponse.SuretyUrl;
          });
        }
      },
      error => {
        //throw error;
        this.alertService.error('Please check your username and password and try again.');
      }
    );
  }

  public AccountSettings() {
    this.router.navigate([AllowedRoutes.AccountSettings]);
  }

  public NavigateToHeaderLink(linkname) {
    if ((this.router.url == AllowedGLNavRoutes.Owner ||
      this.router.url == AllowedGLNavRoutes.Ratings ||
      this.router.url == AllowedGLNavRoutes.Liability ||
      this.router.url == AllowedGLNavRoutes.ExcessCoverage ||
      this.router.url == AllowedGLNavRoutes.Property ||      
      this.router.url == AllowedEXNavRoutes.Owner ||
      this.router.url == AllowedEXNavRoutes.Ratings ||      
      this.router.url == AllowedPLNavRoutes.Owner ||
      this.router.url == AllowedPLNavRoutes.Ratings ||             
      this.router.url == AllowedEXNavRoutes.Excess ||
      this.router.url == AllowedEXNavRoutes.Automobile ||
      this.router.url == AllowedEXNavRoutes.Employeebenefits
      ) && sessionStorage.cachedState == 'true') {

      //Display pop up
      let content = {
        value: Messages.DirtyCheck
      };
      this.dialogConfig.data = content;

      this.dialogConfig.modalSetting = {
        title: this.titleText,
        hideHeader: this.hideHeader,
        hideFooter: true,
        hideSave: this.hideSave,
        hideHeaderX: this.hideHeaderX,
        SaveButton: 'Yes',
        CancelButton: 'No',
        dialogSize: DialogSize.SM
      };
      const ref = this.dialogService.open(
        DialogContainerComponent
        , this.dialogConfig
      );
      ref.afterClosed.subscribe(result => {
        if (result) {
          if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup) {
            this.saveChangeGaurd.formGroup.markAsPristine();
          }

          if (linkname == "header") {
            this.commonContentService.setPageTitle();
            this.resetPropertyOnNewQuote();
            this.router.navigate([this.navigationUrl]);
          }
          else if (linkname == "newquote") {
            this.commonContentService.setPageTitle();
            this.resetPropertyOnNewQuote();
            this.globalVariables.policyTypeId = this.policyTypeId;
            this.globalVariables.subCompanyCode = this.subCompanyCode;
            this.globalVariables.productName =
              this.name === ProductType.General || this.name === ProductType.RemodelingGL
                ? ProductType.General
                : this.name;

            this.router.navigate([this.navigationUrl]);
          }
          else if (linkname == "welcome") {
            if (this.navigationUrl == HeaderMenu.Logout) {
              this.logout();
            }
            else if (this.navigationUrl == HeaderMenu.Search) {
              this.router.navigate([AllowedRoutes.Dashboard]);
            }
            else if (this.navigationUrl == HeaderMenu.AccountSettings) {
              this.AccountSettings();
            }
            else if (this.navigationUrl == HeaderMenu.Surety) {
              this.Surety();
            }
            else if (this.navigationUrl == HeaderMenu.AgencyAdmin){
              this.router.navigate([AllowedRoutes.AgencyAdmin]);
            }
          }
        }
      });

    }
    else if (linkname == "header") {
      if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup && this.saveChangeGaurd.formGroup.dirty) {
        //Form is dirty, Please display pop up
        let content = {
          value: Messages.DirtyCheck
        };
        this.dialogConfig.data = content;

        this.dialogConfig.modalSetting = {
          title: this.titleText,
          hideHeader: this.hideHeader,
          hideFooter: true,
          hideSave: this.hideSave,
          hideHeaderX: this.hideHeaderX,
          SaveButton: 'Yes',
          CancelButton: 'No',
          dialogSize: DialogSize.SM
        };
        const ref = this.dialogService.open(
          DialogContainerComponent
          , this.dialogConfig
        );
        ref.afterClosed.subscribe(result => {
          if (result) {
            if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup) {
              this.saveChangeGaurd.formGroup.markAsPristine();
            }
            this.commonContentService.setPageTitle();
            this.resetPropertyOnNewQuote();
            this.router.navigate([this.navigationUrl]);
          }
          else {
            this.navigationUrl = '';
          }
        });
      }
      else {
        //Form is not dirty, Pop up not required.
        this.commonContentService.setPageTitle();
        this.resetPropertyOnNewQuote();
        this.router.navigate([this.navigationUrl]);
      }
    }
    else if (linkname == "newquote") {
      if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup && this.saveChangeGaurd.formGroup.dirty) {

        //Form is dirty, Please display pop up
        let content = {
          value: Messages.DirtyCheck
        };
        this.dialogConfig.data = content;

        this.dialogConfig.modalSetting = {
          title: this.titleText,
          hideHeader: this.hideHeader,
          hideFooter: true,
          hideSave: this.hideSave,
          hideHeaderX: this.hideHeaderX,
          SaveButton: 'Yes',
          CancelButton: 'No',
          dialogSize: DialogSize.SM
        };
        const ref = this.dialogService.open(
          DialogContainerComponent
          , this.dialogConfig
        );
        ref.afterClosed.subscribe(result => {
          if (result) {
            if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup) {
              this.saveChangeGaurd.formGroup.markAsPristine();
            }
            this.commonContentService.setPageTitle();
            this.resetPropertyOnNewQuote();
            this.globalVariables.policyTypeId = this.policyTypeId;
            this.globalVariables.subCompanyCode = this.subCompanyCode;
            this.globalVariables.productName =
              this.name === ProductType.General || this.name === ProductType.RemodelingGL
                ? ProductType.General
                : this.name;

            this.router.navigate([this.navigationUrl]);
          }
          else {
            this.navigationUrl = '';
          }
        });
      }
      else {
        //Form is not dirty, Pop up not required.
        this.commonContentService.setPageTitle();
        this.resetPropertyOnNewQuote();
        this.globalVariables.policyTypeId = this.policyTypeId;
        this.globalVariables.subCompanyCode = this.subCompanyCode;
        this.globalVariables.productName =
          this.name === ProductType.General || this.name === ProductType.RemodelingGL
            ? ProductType.General
            : this.name;

        this.router.navigate([this.navigationUrl]);
      }
    }
    else if (linkname == "welcome") {
      if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup && this.saveChangeGaurd.formGroup.dirty) {

        //Form is dirty, Please display pop up
        let content = {
          value: Messages.DirtyCheck
        };
        this.dialogConfig.data = content;

        this.dialogConfig.modalSetting = {
          title: this.titleText,
          hideHeader: this.hideHeader,
          hideFooter: true,
          hideSave: this.hideSave,
          hideHeaderX: this.hideHeaderX,
          SaveButton: 'Yes',
          CancelButton: 'No',
          dialogSize: DialogSize.SM
        };
        const ref = this.dialogService.open(
          DialogContainerComponent
          , this.dialogConfig
        );
        ref.afterClosed.subscribe(result => {
          if (result) {
            if (this.saveChangeGaurd && this.saveChangeGaurd.formGroup) {
              this.saveChangeGaurd.formGroup.markAsPristine();
            }
            if (this.navigationUrl == HeaderMenu.Logout) {
              this.logout();
            }
            else if (this.navigationUrl == HeaderMenu.Search) {
              this.router.navigate([AllowedRoutes.Dashboard]);
            }
            else if (this.navigationUrl == HeaderMenu.AccountSettings) {
              this.AccountSettings();
            }
            else if (this.navigationUrl == HeaderMenu.Surety) {
              this.Surety();
            }
            else if (this.navigationUrl == HeaderMenu.AgencyAdmin){
              this.router.navigate([AllowedRoutes.AgencyAdmin]);
            }
          }
          else {
            this.navigationUrl = '';
          }
        });
      }
      else {
        //Form is not dirty, Pop up not required.
        if (this.navigationUrl == HeaderMenu.Logout) {
          this.logout();
        }
        else if (this.navigationUrl == HeaderMenu.Search) {
          this.router.navigate([AllowedRoutes.Dashboard]);
        }
        else if (this.navigationUrl == HeaderMenu.AccountSettings) {
          this.AccountSettings();
        }
        else if (this.navigationUrl == HeaderMenu.Surety) {
          this.Surety();
        }
        else if (this.navigationUrl == HeaderMenu.AgencyAdmin){
          this.router.navigate([AllowedRoutes.AgencyAdmin]);
        }
      }
    }
  }
}
